import EditIcon from "@mui/icons-material/Edit";
import { Box, Button } from "@mui/material";
import { isNil } from "lodash";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../core/app/AppContextProvider";
import EntrancesList from "../entrances/EntrancesList";
import { BaseLocationAutocomplete, useQueryLocationAutocomplete } from "../hints/LocationAutocomplete";
import { LocationDto } from "../locations/LocationDtos";
import { useQuerySubLocations } from "../locations/LocationQuery";
import { CheckDto } from "./CheckDataType";
import { useQueryChecksByLocation } from "./CheckQuery";
import { getSubTypeData } from "./type/CheckSubTypeHelper";
import { useSelector } from "react-redux";
import { AppState } from "../../core/app/AppReducer";
import { setChecksLocation, setChecksSubLocation } from "../OotrReducer";
import { useDispatch } from "react-redux";

const CheckLogicScreen = () => {

    let location = useSelector((state: AppState) => state.ui.ootr.main.location)
    let subLocation = useSelector((state: AppState) => state.ui.ootr.main.sublocation)
    let dispacth = useDispatch();
    
    let searchLocation = isNil(subLocation) ? location : subLocation;

    let { data: locations } = useQueryLocationAutocomplete();
    let { data: subLocations } = useQuerySubLocations(searchLocation?.id);
    let { data: locationsChecks } = useQueryChecksByLocation(searchLocation?.id);
    // let { data: subLocationsChecks } = useQueryChecks(subLocation?.id);

    function selectEntrance(location: LocationDto | null) {
        if (locations.some(x => x.id === location?.id)) {
            dispacth(setChecksLocation(location));
            dispacth(setChecksSubLocation(null));
        }
        else {
            dispacth(setChecksSubLocation(location));
        }
    }

    return <Box display="flex" flexDirection={"column"}>
        <Box display="flex" flexDirection={"column"}>
            <Box display="flex">
                <h2>Check / Entrances / Event Logic</h2>
            </Box>
            <Box display="flex" flexDirection={"row"}>
                <BaseLocationAutocomplete data={locations} label="Location" selection={location} additionalOnChange={(loc) => { dispacth(setChecksLocation(loc)); dispacth(setChecksSubLocation(null)); }} sx={{ width: "300px" }} />
                <BaseLocationAutocomplete data={subLocations} label="Sub-Locations" selection={subLocation} additionalOnChange={(v) => dispacth(setChecksSubLocation(v))} sx={{ width: "300px", marginLeft: "5px" }} />
            </Box>
        </Box>
        <Box display={"flex"} flexDirection={"row"}>
            {!isNil(searchLocation) && locationsChecks.length > 0 && <Box display={"flex"} flexDirection={"column"} marginLeft={5}>
                <h2>Checks in {searchLocation?.name}</h2>
                {locationsChecks.map(c => {

                    return <CheckLogicElement check={c} />
                })}
            </Box>}

            <EntrancesList locationId={searchLocation?.id} selectLocation={selectEntrance} />

        </Box>
        {/* 
        {!isNil(subLocation) && subLocationsChecks.length > 0 && <Box display={"flex"} flexDirection={"column"} marginLeft={5}>

            <h2>Checks in {subLocation?.name}</h2>
            {subLocationsChecks.map(c => {
                return <CheckLogicElement check={c} />
            })}
        </Box>} */}
    </Box>
}

export default CheckLogicScreen;

// interface LocationElementProps {
//     location: LocationDto
//     selectedLocation: LocationDto | null,
//     setLocation: (loc: LocationDto | null) => void
//     width: number
// }

// const LocationElement = (props: LocationElementProps) => {


//     let color = "inherit"
//     let textColor = "inherit"
//     if (props.selectedLocation?.id === props.location?.id) {
//         color = "lightgreen !important"
//         textColor = "black"
//     }

//     return <Box display="flex" width={props.width} sx={{ backgroundColor: color, color: textColor, cursor: "pointer" }} onClick={() => { props.setLocation(props.location) }}>{props.location.name}</Box>
// }

interface CheckLogicElementProps {
    check: CheckDto
}

const CheckLogicElement = (props: CheckLogicElementProps) => {


    let appContext = useAppContext();

    let data = getSubTypeData(props.check.checkSubType?.id)

    let navigate = useNavigate();

    return <Box display={"flex"} borderTop={"1px solid white"} borderBottom={"1px solid white"}>
        {appContext.user?.isAdmin && appContext.isAuthenticated && <Box display={"flex"} flexBasis={"fit-content"}>
            <Button startIcon={<EditIcon />} onClick={() => navigate("/ootr/checks/" + props.check.id + "/edit")} />
        </Box>}
        <Box display={"flex"} width={200} alignItems={"center"} color={data.color}>
            {props.check.name}
        </Box>
        <Box display={"flex"} width={250}>
            {props.check.logic}
        </Box>
        <Box display={"flex"} flexBasis={"fit-content"} alignItems={"center"} justifyContent={"center"}>
            {!isNil(data.img) && <img width={data.width ?? 30} height={30} src={data.img} alt={""} />}
        </Box>
    </Box>
}